import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';
import styles from './PasswordValidationList.style';
import { PasswordValidationListProps, PasswordValidationResult } from './types';

const PasswordValidationList = ({
  validations,
  show,
}: PasswordValidationListProps) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className={styles.container}>
      {Object.keys(validations)
        .filter((key) => key !== 'isValid')
        .map((validation) => {
          const isValid =
            validations[validation as keyof PasswordValidationResult];
          return (
            <p key={validation} className={styles.validationItem(isValid)}>
              {isValid ? (
                <CheckCircleOutlineIcon className={styles.validIcon} />
              ) : (
                <HighlightOffIcon className={styles.invalidIcon} />
              )}{' '}
              {t(validation)}
            </p>
          );
        })}
    </div>
  );
};

export default PasswordValidationList;
